<template>
    <v-window v-model="TabsSecondaryValue" v-bind="$attrs" @change="TabsSecondaryValueChange">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </v-window>
</template>

<script>
export default {
    props: {
        value: { type: [Number, String] },
    },
    components: {},
    data: () => {
        return {};
    },
    computed: {
        TabsSecondaryValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("change", newValue);
            },
        },
    },
    mounted() {},
    methods: {
        TabsSecondaryValueChange(newValue) {
            this.TabsSecondaryValue = newValue;
        },
    },
};
</script>

<style lang="scss" scoped></style>